<div class="reports-main">
  <div class="reports-header-main">
    <div class="reports-header">
      <wm-common-text
        [data]="{
          text: 'Reports'
        }"
      ></wm-common-text>
    </div>
  </div>
  <mat-tab-group
    class="main-tab"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    mat-dynamic-height="true"
    animationDuration="10ms"
    [selectedIndex]="selectedIndex"
    (selectedIndexChange)="onTabChange($event)"
  >
    @for (tab of tabsList; track tab) {
      <mat-tab [label]="formatTabLabel(tab)"></mat-tab>
    }
  </mat-tab-group>
  <!-- SUB TABS -->
  <div class="sub-tabs-container">
  @if (subTabsList[activeMainTab]?.length) {
      <div class="sub-tabs">
        @for (subTab of subTabsList[activeMainTab]; track subTab.route) {
          <div class="sub-tab-btn" [class.active]="activeSubTab === subTab.route">
            <wm-common-button
              [data]="{ text: subTab.label }"
              (click)="onSubTabClick(subTab.route)"
            ></wm-common-button>
          </div>
        }
      </div>
    }

    <div class="reports-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

